import { makeStyles } from '@providers/Theme';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    flex: 1,
  },
  accordion: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center',
    borderBottomColor: theme.palette.grey[300],
    borderBottomWidth: 2,
  },
  listItem: {
    borderBottomColor: theme.palette.grey[300],
    borderBottomWidth: 1,
    marginHorizontal: 16,
    flexDirection: 'row',
    paddingVertical: theme.spacing(2),
  },
  price: { marginRight: 8 },
  bulkToggle: { marginLeft: 8 },
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'flex-start',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  toggles: {
    on: {
      md: {
        flexDirection: 'row',
        width: 'auto',
      },
      xs: {
        width: '100%',
      },
    },
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'row',
    padding: theme.spacing(2),
    height: '95%',
  },
  updateBtnContainer: {
    paddingVertical: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    on: {
      md: {
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    },
  },
  searchWrapper: {
    width: '100%',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(2),
    on: {
      md: {
        width: '40%',
        marginTop: theme.spacing(0),
      },
    },
  },
  searchInput: {
    paddingRight: theme.spacing(4),
    position: 'relative',
  },
  closeBtn: {
    width: 'auto',
    padding: theme.spacing(1),
    position: 'absolute',
    right: theme.direction === 'rtl' ? 'auto' : 8,
    left: theme.direction === 'rtl' ? 8 : 'auto',
    top: '36%',
  },
  icon: { marginTop: 4 },
}));
